import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import fig from "./login_user.png";

export const UserLogin = () => {
  return (
    <Flex h="100vh">
      <Image src={fig} w="50%" objectFit="cover" />
      <LoginArea />
    </Flex>
  );
};

const LoginArea = () => {
  const signIn = () => {
    window.location.assign(import.meta.env.VITE_USER_LOGIN_COGNITO_URL);
  };

  return (
    <Box h="full" w="full" bgColor="#0f2446">
      <Flex direction={"column"} justifyContent="center" h="full">
        <Flex direction={"row"} justifyContent="space-between" mb={4}>
          <Text
            color="#FFFFFF"
            ml={100}
            overflow="hidden"
            fontWeight="bold"
            whiteSpace="nowrap"
            fontSize={"4xl"}
            w="fit-content"
          >
            ログイン
          </Text>
          <Text
            bgColor="#FFFFFF"
            textColor="gray.900"
            borderRadius={10}
            py={2}
            px={"5vw"}
            mr={100}
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize={"2xl"}
            fontWeight={"bold"}
          >
            特約店用
          </Text>
        </Flex>
        <Box my={4} mx={100}></Box>
        <Box mt={4} mx={100}>
          <Button
            onClick={signIn}
            my={2}
            bgColor="#1e6cf2"
            color="gray.50"
            w="full"
            borderRadius="20"
          >
            ログイン
          </Button>
          {/* <Button onClick={signUp}>Create Account</Button> */}
        </Box>
      </Flex>
      <Text
        position="fixed"
        bottom={"10%"}
        justifyContent="center"
        color={"#FFFFFF"}
        justifyItems="center"
        textAlign="center"
        left={"75%"}
        transform={"translateX(-50%)"}
        w="full"
      >
        SUBAROAD MAKERのアカウントをお持ちでない方は、{<br />}
        アカウントをお持ちの方にユーザーの追加発行を依頼してください。
      </Text>
    </Box>
  );
};
